import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Logindetail.css";
import "./businessmobile.css";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
// import Button from "@mui/material/Button";
// import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
// import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { useDispatch } from "react-redux";
import { SetUserToken } from "../../../Store/UserTokenSlice";
import { SetAuthToken } from "../../../Store/ApiAuthKey";
import logoimage from '../Asset/New_Assert/ESO_Logo.png';
// import LogoutIcon from '@mui/icons-material/Logout';
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import { toast } from "react-toastify";
import 'react-phone-input-2/lib/material.css';
import PhoneInput from "react-phone-input-2";
import Loader from "../CommonLoader";
import { borderRadius } from "@mui/system";



function BusinessMobile() {

    const location = useLocation();
    const signUpData = location.state || {};
    // const [toggle, setToggle] = useState(false);
    // const [faqData, setfaqData] = useState("2")
    // const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
    const [loading, setLoading] = useState(false);
    const esodata = useSelector((state) => state);
    const navigate = useNavigate();
    const [apiopen, setapiOpen] = React.useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const sign = require("jwt-encode");
    const [formData, setFormData] = useState({
        mobile: null,
        business: null,
    });
    const [formError, setFormError] = useState({
        mobileErr: null,
        businessErr: null,
    });
    const dispatch = useDispatch();

    const apihandleClose = () => {
        setapiOpen(false);
    };

    const ApiToken = esodata.apiauthkey.value;

    // const TriggerLogout = async () => {
    //     try {
    //         const datavalue = await axios.get(
    //             `${process.env.REACT_APP_API_URL}accounts/logout/`,
    //             {
    //                 headers: {
    //                     Authorization: `Token ${ApiToken}`,
    //                 },
    //             }
    //         );

    //         if (datavalue.data) {

    //             localStorage.setItem("eso_auth_token", "");
    //             localStorage.setItem("eso_user_token", "");
    //             dispatch(SetUserToken({ eso_user_token: "" }));
    //             dispatch(SetAuthToken({ eso_auth_token: "" }));
    //             navigate("/login");
    //         }
    //     } catch (err) {
    //         localStorage.setItem("eso_auth_token", "");
    //         localStorage.setItem("eso_user_token", "");
    //         dispatch(SetUserToken({ eso_user_token: "" }));
    //         dispatch(SetAuthToken({ eso_auth_token: "" }))
    //         navigate("/login");
    //     }
    // };

    const handleChange = (e) => {
        var { name, value } = e.target;
        var errName = 'businessErr';
        var errValue = 'Please enter the Business Name';

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setFormError((prev) => ({
            ...prev,
            [errName]: value !== '' ? null : errValue
        }));
    };

    const handlePhoneChange = (e, data) => {

        var { name, value } = { name: 'mobile', value: e };
        var errValue = null;

        const number = value.slice(data.dialCode.length);
        const format = data.format.split(/[()\-\+\s]+/).filter(Boolean).join('');

        if (format.length !== (data.dialCode + number).length) {
            errValue = 'Please enter the valid Phone Number.';
        } else if (value === '' || number === '') {
            errValue = 'Please enter the Phone Number.';
        }

        setFormData((prev) => ({
            ...prev,
            [name]: data.dialCode + '-' + number,
        }));
        setFormError((prev) => ({
            ...prev,
            ['mobileErr']: errValue
        }));
    };

    const submitForm = (e) => {
        e.preventDefault();
        if (!formData.business || !formData.mobile || formError.businessErr || formError.mobileErr) {
            setFormError((prev) => ({
                ...prev,
                businessErr: !formData.business ? 'Please enter the Business Name' : formError.businessErr ? formError.businessErr : null,
                mobileErr: !formData.mobile ? 'Please enter the Phone Number' : formError.mobileErr ? formError.mobileErr : null,
            }));
        } else {
            SingUpOrLogInwithgoogle();
        }
    }

    const SingUpOrLogInwithgoogle = async (action = "", res = "") => {
        console.log('formData', formData);
        setLoading(true);
        var datas = {
            name: signUpData.name || '',
            email: signUpData.email || '',
            type: signUpData.type || '',
            phone_no: formData.mobile,
            business_name: formData.business
        };

        const jwt_datas = sign(datas, "VdM1t3n0NiD_Qsawq7ZX");
        try {
            const response = await axios
                .post(
                    `${process.env.REACT_APP_API_URL}accounts/save_social_login_data/`,
                    { data: jwt_datas }
                )
                .catch((error) => {
                    setLoading(false);
                    if (
                        error?.response?.status === 599 ||
                        error?.response?.status === 500 ||
                        error?.response?.status === 400 ||
                        error?.response?.status === 404
                    ) {
                        setapiOpen(true);
                        setapierrorMsg(error?.response?.data?.error);
                    } else if (error?.code === "ERR_NETWORK") {
                        navigate("/login-errorpages");
                    }
                });
            if (response?.data?.token) {
                dispatch(SetUserToken({ eso_user_token: response.data.token }));
                dispatch(
                    SetAuthToken({ eso_auth_token: "Token " + response.data.token })
                );
                window.location.href = `${process.env.REACT_APP_DOMAIN}`;
                // navigate(process.env.REACT_APP_DOMAIN);
            }
        } catch (err) {
            setLoading(false);
            toast.error(err.response.data.error, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        console.log('signUpData', signUpData);
        if (!signUpData.email) {
            navigate('/');
        }
    }, [])



    return (
        <div className="userdata addrs">
            {loading === true ? <Loader /> : null}
            <div className="header_wrap" style={{ background: "#fff" }}>
                <div className="header_inner_top_wrap">
                    <div className="drp_outer_wrap">
                        <div class="Logo_wrap1">
                            <img src={logoimage} alt="ESO Logo" class="Siteimage" style={{ width: "160px" }}></img>
                        </div>
                    </div>
                </div>
                <div className="header_inner_btm_wrap" style={{ gap: "5px" }}>
                    <div className="bell-container top_icons_grp" >
                        <span className="account_set_wrap">
                            {/* <button style={{ background: "#fff" }}
                            onClick={handleToggle}
                            title="Frequently Asked Question">
                            <QuestionMarkIcon />
                          </button> */}
                        </span>
                    </div>
                    {/* {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />} */}
                    <div className="bell-container top_icons_grp" >
                        <span className="account_set_wrap">
                            {/* <button style={{ background: "#fff" }}
                            onClick={TriggerLogout}
                            title="Logout">
                            <LogoutIcon />
                          </button> */}
                        </span>
                    </div>
                </div>
            </div>

            {/* <div className="cnt_hdr_top_rgt_wrap" style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "10px", background: "#fff", position: "fixed", zIndex: 999 }}>
                <img
                    className="Eso_logo"
                    src={logoimage}
                    alt="logo"
                    style={{ width: "14%", background: "#fff" }}
                />
            </div> */}
            <div className="outer-container"
                style={{
                    // marginTop: "10rem",
                    placeItems: "center",
                    marginBottom: "4rem",
                    minHeight: "auto"
                }}
            >
                <div className="userdata_inner">
                    <h1>User Details</h1>
                    <form>
                        <div>
                            <div>
                                <label htmlFor="mobile">Phone Number:</label>
                                <PhoneInput
                                    name='mobile'
                                    country={'us'}
                                    enableSearch={true}
                                    value={formData.mobile || ''}
                                    onChange={handlePhoneChange}
                                    preferredCountries={['us', 'in']}
                                    inputClass="custom-phone-input"
                                    specialLabel=""
                                    placeholder=""
                                    inputProps={{
                                        maxLength: 40 // Increase length if needed
                                    }}
                                    style={{ border: "1px solid #ff601f", borderRadius: "5px" }}
                                    enableLongNumbers={true}
                                />
                            </div>
                            <div>
                                <span className="err">{formError.mobileErr}</span>
                            </div>
                        </div>
                        <div style={{ margin: "20px 0px" }}>
                            <div>
                                <div>
                                    <label htmlFor="business">Business Name:</label>
                                    <input
                                        type="text"
                                        id="business"
                                        name="business"
                                        title="Business"
                                        placeholder="Enter Business"
                                        value={formData.business || ''}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div>
                                    <span className="err">{formError.businessErr}</span>
                                </div>
                            </div>

                        </div>

                        {/* <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                            <Button
                                className="steppersubmitform"
                                variant="contained"
                                color="primary"
                                onClick={finalreportNow}
                                disabled={!Country}
                                sx={{
                                    padding: "10px 15px",
                                    borderRadius: "10px",

                                    fontSize: "16px",
                                    backgroundColor: !Country ? "#ccc" : "#ff601f",
                                    color: !Country ? "#666" : "white",
                                    "&:hover": {
                                        backgroundColor: !Country ? "#ccc" : "#ff7d45",
                                    },
                                }}
                            >
                                Next <FastForwardIcon />

                            </Button>
                        </Box> */}

                        <div style={{ placeSelf: 'center' }}>
                            <button
                                className="keyword-submit"
                                style={{ margin: "auto", marginTop: "20px" }}
                                onClick={submitForm}
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <CommonErrorAlert
                data={{
                    apiopen: apiopen,
                    apiErrorMsg: apierrorMsg,
                    isIconStyled: true
                }}
                closeAlert={apihandleClose} />
        </div>

    );
}
export default BusinessMobile;